module.exports = __webpack_public_path__ + "assets/img/ring_red.66cca225.png";